import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import BatchTable from "../batchTable";
import { Refresh } from "@material-ui/icons";
import { FormControl, Grid, MenuItem, Select } from "@material-ui/core";
import moment from "moment";
import ReceivedTable from "../tables/Received";
import DispatchedTable from "../tables/Dispatched";
import UnderApprovalTable from "../tables/UnderApproval";
import ProductionCompleteTable from "../tables/ProductionComplete";
import UnderProductionTable from "../tables/UnderProduction";
import ScheduledTable from "../tables/Scheduled";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";
import { CircularProgress } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "20px",
  },
  tabs: {
    backgroundColor: "#fff", // White background for tabs
    color: "#000", // Default text color for tabs
    display: "flex", // Ensures tabs align properly in a flex layout
    justifyContent: "flex-start", // Align tabs to the left
    padding: theme.spacing(0, 1), // Add horizontal padding for better spacing
    minHeight: "48px", // Set a consistent height for tabs
  },
  tab: {
    textTransform: "none",
    fontSize: "14px",
    fontWeight: 500,
  },
  selectedTab: {
    color: "#5f90db", // Blue text color for the selected tab
    fontWeight: 500, // Bold font for selected tab
    fontSize: "14px",
  },
  indicator: {
    backgroundColor: "#5f90db", // Blue indicator for selected tab
    height: "3px", // Adjust indicator thickness
  },
}));

export default function DetailTab({ data }) {
  // console.log("DetailTab:", data);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [apiData, setApiData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [statusTable, setStatusTable] = useState({});
  const [refresh, setRefresh] = useState(false);
  const [quantityPercentage, setquantityPercentage] = useState({});

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleRefresh = () => {
    setRefresh(!refresh);
    setError(null);
  };
  useEffect(() => {
    setLoading(true);
    axios
      .post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}/fetchAllBatchesForSL
      `,
        {
          schrockenSLID: data.schrockenSLID,
          committedQuantity: data.committedQuantity,
          // committedQuantity: 30,
        }
      )
      .then((res) => {
        // throw new Error("mock error");
        if (res.data.status) {
          const statusData = res.data.data.statusBasedBatchDetailsList;
          // Prepare the status table and quantity percentage map
          const statusMap = {};
          const quantityPercentageMap = {};
          statusData.forEach((item) => {
            const status = item.batchData.statusDescription;
            statusMap[status] = item.batchDetailsList || [];
            quantityPercentageMap[status] = item.batchData.quantityPercentage;
          });

          //  statusMap = statusData.reduce((acc, item) => {
          //   const status = item.batchData.statusDescription;
          //   setquantityPercentage((prevQty) => ({
          //     ...prevQty,
          //     [status]: item.batchData.quantityPercentage,
          //   }));
          //   acc[status] = item.batchDetailsList || [];
          //   return acc;
          // }, {});
          setStatusTable(statusMap);
          setquantityPercentage(quantityPercentageMap);
          setApiData(res.data.data.statusBasedBatchDetailsList);
          setLoading(false);
          setError(null);
        }
      })
      .catch((err) => {
        setLoading(false);
        setError(err);
        console.error("Error", err.message);
      });
  }, [refresh]);
  // console.log("QuantityPercentage", quantityPercentage);
  const formatQuantityPercentage = (value) => {
    if (value === undefined) {
      return 0; // Fallback to 0 if the value is undefined
    }
    return Number.isInteger(value) ? value : value.toFixed(3); // Check if value is an integer, otherwise round to 2 decimal points
  };
  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center", // Horizontally center the CircularProgress
          alignItems: "center", // Vertically center the CircularProgress
          height: "50px", // Optional: Set a height to vertically center the loader
          border: "2px solid #FF0000",
          backgroundColor: "#FFF0F0",
          width: "100%",
          marginTop: "50px",
        }}
      >
        <Typography style={{ textAlign: "center" }}>
          Something went wrong. Please try again.
        </Typography>
      </div>
    );
  }
  if (loading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <CircularProgress color="primary" thickness={7} />
      </div>
    );
  }
  return (
    <div className={classes.root}>
      <Grid container alignItems="center" justifyContent="space-between">
        {/* Tabs */}
        <Grid item xs={10}>
          {" "}
          {/* Adjust `xs` to allocate space */}
          <Tabs
            value={value}
            onChange={handleChange}
            classes={{
              root: classes.tabs,
              indicator: classes.indicator,
            }}
          >
            <Tab
              label={`Received (${(statusTable["Received"] || []).length})`}
              {...a11yProps(0)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
            <Tab
              label={`Dispatched (${(statusTable["Dispatched"] || []).length})`}
              {...a11yProps(1)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
            <Tab
              label={`Under approval (${
                (statusTable["Under approval"] || []).length
              })`}
              {...a11yProps(2)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
            <Tab
              label={`Production complete (${
                (statusTable["Production complete"] || []).length
              })`}
              {...a11yProps(3)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
            <Tab
              label={`Under production (${
                (statusTable["Under production"] || []).length
              })`}
              {...a11yProps(4)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
            <Tab
              label={`Scheduled (${(statusTable["Scheduled"] || []).length})`}
              {...a11yProps(5)}
              classes={{ root: classes.tab, selected: classes.selectedTab }}
            />
          </Tabs>
        </Grid>

        {/* Last Synced and PER PAGE */}
        <Grid item xs={2}>
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            style={{
              marginTop: "10px",
            }}
          >
            {/* Last synced */}
            <Typography
              variant="body2"
              style={{
                color: "gray",
                marginRight: "8px",

                whiteSpace: "nowrap",
              }}
            >
              {`Last synced @ ${moment(new Date()).format(
                "HH:mm:ss; DD MMMM, YYYY"
              )}`}
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              style={{
                textDecoration: "underline",
                fontStyle: "italic",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleRefresh}
            >
              Refresh
              <Refresh color="primary" fontSize="small" />
            </Typography>

            {/* PER PAGE */}
            {/* <Grid
              style={{
                display: "flex",
                alignItems: "center",
                marginLeft: "16px",
              }}
            >
              <Typography
                style={{
                  fontWeight: "bold",
                  marginRight: "4px",
                  whiteSpace: "nowrap",
                }}
              >
                PER PAGE
              </Typography>
              <FormControl variant="outlined" size="small">
                <Select value={10}>
                  <MenuItem value={3}>3</MenuItem>
                  <MenuItem value={5}>5</MenuItem>
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={15}>15</MenuItem>
                </Select>
              </FormControl>
            </Grid> */}
          </Grid>
        </Grid>
      </Grid>

      <Box>
        <Typography variant="body2" style={{ marginTop: "20px" }}>
          Quantity % for each of the below tab is:
        </Typography>
        <Typography gutterBottom variant="body2">
          Received ({formatQuantityPercentage(quantityPercentage["Received"])}),
          Dispatched (
          {formatQuantityPercentage(quantityPercentage["Dispatched"])}), Under
          approval (
          {formatQuantityPercentage(quantityPercentage["Under approval"])}),
          Production complete (
          {formatQuantityPercentage(quantityPercentage["Production complete"])}
          ), Under Production (
          {formatQuantityPercentage(quantityPercentage["Under production"])}),
          Scheduled ({formatQuantityPercentage(quantityPercentage["Scheduled"])}
          )
          {/* Received ({(statusTable["Received"] || []).length}), Dispatched (
          {(statusTable["Dispatched"] || []).length}). Under approval (
          {(statusTable["Under approval"] || []).length}), Production complete (
          {(statusTable["Production complete"] || []).length}), Under Production
          ({(statusTable["Under production"] || []).length}), Scheduled (
          {(statusTable["Scheduled"] || []).length}) */}
        </Typography>
      </Box>

      <TabPanel value={value} index={0}>
        <ReceivedTable data={statusTable["Received"] || []} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <DispatchedTable data={statusTable["Dispatched"] || []} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <UnderApprovalTable data={statusTable["Under approval"] || []} />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ProductionCompleteTable
          data={statusTable["Production complete"] || []}
        />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <UnderProductionTable data={statusTable["Under production"] || []} />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <ScheduledTable data={statusTable["Scheduled"] || []} />
      </TabPanel>
    </div>
  );
}
